// Copyright ©️ 2026 eVolve MEP, LLC

import { StatusBadge } from 'components/Mantine/StatusBadge';

type Props = {
  isClosed?: boolean;
};

export const ActiveClosedStatusBadge = ({ isClosed }: Props) => (
  <StatusBadge color={isClosed ? 'gray.7' : 'teal.6'} label={isClosed ? 'Closed' : 'Active'} />
);
